$(document).ready(function() {
  $(".inner-chain-title").click(function() {
    // 切换当前点击的 .inner-chain-item 的显示状态
    $(this).next(".inner-chain-item").toggle();

    // 检查当前点击的 .inner-chain-title img 是否有 rotate 类
    if ($(this).find("img").hasClass("rotate")) {
      // 如果有 rotate 类，则移除 rotate 类并添加 rotate1 类
      $(this).find("img").removeClass("rotate").addClass("rotate1");
    } else {
      // 如果没有 rotate 类，则移除 rotate1 类并添加 rotate 类
      $(this).find("img").removeClass("rotate1").addClass("rotate");
    }
  });

// 初始时隐藏所有相关表单部分
  $('.mood-cause, .good-mood-more, .website-form, .promotion-form, #website_textarea, #promotion_textarea').hide();

  $('.mood-item').click(function() {
    // 移除所有 mood-item 的 mood-item-active 类名
    $('.mood-item').removeClass('mood-item-active');
    $('.feedback-email').show();
    // 缓存当前点击的元素
    var currentItem = $(this);
    
    // 根据当前元素的类名，添加 mood-item-active 类名并显示相应的表单部分
    if (currentItem.hasClass('bad-mood')) {
      console.log("Bad Mood");
      currentItem.addClass('mood-item-active');
      $('.mood-cause').show();
      // 隐藏其他表单部分
      $('.good-mood-more').hide();
    } else if (currentItem.hasClass('good-mood')) {
      console.log("Good mood");
      currentItem.addClass('mood-item-active');
      $('.good-mood-more').show();
      // 隐藏其他表单部分
      $('.mood-cause').hide();
    }
  });

  $('.mood-cause-item').click(function() {
    // 给当前点击的元素切换 active 类名
    $(this).toggleClass('active');
    
    // 根据当前元素的类名显示或隐藏相应的表单部分
    var causeItemClass = $(this).attr('class').split(/\s+/).find(function(className) {
      return className.startsWith('mood-cause-item') === false;
    });

    if (causeItemClass === 'website') {
      $('.website-form').toggle();
      $('#website_textarea').toggle();
    } else if (causeItemClass === 'promotion') {
      $('.promotion-form').toggle();
      $('#promotion_textarea').toggle();
    }
    // 可以继续添加其他条件来处理其他类名
  });

  // 为每个 input-item 添加点击事件监听器
  $('.input-item').click(function() {
    // 找到当前 input-item 内的 input 元素
    var input = $(this).find('input[type="checkbox"]');

    // 切换 checked 属性
    input.prop('checked', !input.prop('checked'));

    // 根据当前 input 的 checked 状态，切换 active 类名
    if (input.prop('checked')) {
      $(this).addClass('active');
    } else {
      $(this).removeClass('active');
    }
  });
});